












import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Wallet } from '@/store/wallet/types';
import { User } from '@/store/profile/types';
import { BankAccount, MangoPayMandates } from '@/store/mangoPay/types';
import ChargeWallet from '@/components/wallet/ChargeWallet.vue';

@Component({
  name: 'charge-wallet-view',
  components: {
    ChargeWallet,
  },
})
export default class ChargeWalletView extends Vue {
  @Getter('wallet/wallet') wallet?: Wallet;
  @Getter('profile/user') user?: User
  @Getter('mangoPay/bankAccounts') bankAccounts?: Array<BankAccount>;
  @Action('wallet/createPayIn') createPayIn: Function;
  @Getter('mangoPay/mandates') mandates: MangoPayMandates;
}
